import { ButtonBase, Grid } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import DazzedParagraph12 from 'components/common/text/DazzedParagraph12'
import React from 'react'

const useStyles = makeStyles(theme => ({
  root: {
    padding: '0 5px',
    height: '100%',
    width: '100%'
  },
  buttonText: {
    color: 'var(--text-color-25)'
  },
  icon: {
    margin: '3px 5px 0 5px'
  }
}))

const ScanActionButton = ({
  icon = <></>,
  children,
  onClick = () => {},
  elementId = 'share-scan-button',
  className = '',
  labelClassName = '',
  iconClassName = '',
  flexWrap,
  disabled = false
}) => {
  const classes = useStyles()

  return (
    <ButtonBase onClick={onClick} className={[classes.root, className].join(' ')} id={elementId} disabled={disabled}>
      <Grid container alignItems="center" className={classes.buttonText} wrap={flexWrap}>
        <Grid item className={[classes.icon, iconClassName].join(' ')}>
          {icon}
        </Grid>
        <DazzedParagraph12 className={[classes.buttonText, labelClassName].join(' ')}>{children}</DazzedParagraph12>
      </Grid>
    </ButtonBase>
  )
}

export default ScanActionButton
